module.exports = __webpack_public_path__ + "img/livingRoom.4146676e.jpg";